export const GET_VENDOR_APPOINTMENTS_BY_ACCESS_CODE_REQUEST = 'GET_VENDOR_APPOINTMENTS_BY_ACCESS_CODE_REQUEST';
export const GET_VENDOR_APPOINTMENTS_BY_ACCESS_CODE_SUCCESS = 'GET_VENDOR_APPOINTMENTS_BY_ACCESS_CODE_SUCCESS';
export const GET_VENDOR_APPOINTMENTS_BY_ACCESS_CODE_FAILURE = 'GET_VENDOR_APPOINTMENTS_BY_ACCESS_CODE_FAILURE';

export const CLEAR_VENDOR_APPOINTMENTS_STATE = 'CLEAR_VENDOR_APPOINTMENTS_STATE';
